import {Component, HostBinding, HostListener, Input, OnInit} from '@angular/core';
import {FolderFormComponent} from "../folder-form/folder-form.component";
import {showOpacityAnimation} from '../../../shared/animations/show-opacity.animation';
import {Store} from '@ngrx/store';
import {AppState} from '../../../shared/store/store';
import {dialogOpen} from '../../../shared/store/dialog/dialog.actions';
import {FolderComponentObject} from '../../../shared/classes/folder-component-object';

@Component({
  selector: 'app-add-folder-card',
  templateUrl: './add-folder-card.component.html',
  styleUrls: ['./add-folder-card.component.scss'],
  animations: [
    showOpacityAnimation
  ]
})
export class AddFolderCardComponent implements OnInit {
  @Input() folder: FolderComponentObject;

  constructor(
    private readonly _store: Store<AppState>
  ) { }

  ngOnInit(): void {
  }

  @HostBinding('@showOpacity') get showOpacity() {
    return 'show';
  }

  @HostListener('click') public click(): void {
    this._store.dispatch(
      dialogOpen({
        component: FolderFormComponent,
        config: {
          width: '500px',
          height: 'auto'
        },
        data: {
          parent: this.folder
        }
      })
    );
  }

}
